import { calcDisplaySafeHeight } from './helpers';
import { documentObserver, observerCallback } from '@/helpers/fixedBody.js';
import { registerAllComponents } from '@/componentRegistry';
import { initDefaultConfig, getConfig } from '@/config';

import.meta.glob('../src/components/**/index.js', {
    import: 'default',
    eager: true,
});

initDefaultConfig();

// после загрузки всех модулей регистрируем компоненты
registerAllComponents();

document.addEventListener('DOMContentLoaded', () => {
    calcDisplaySafeHeight();
    observerCallback();
    documentObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
    });
    const config = getConfig();
    if (config?.events?.load) {
        document.dispatchEvent(new Event(config.events.load));
    }
});
